/**
 * Доступ до дашборда цеху (начальник зміни / цеху / адмін / явне право).
 */
export function canAccessShiftFloor(currentUser) {
  if (!currentUser) return false;
  const perms = currentUser.effective_permissions || {};
  if (perms['menu.shift_floor'] === false) return false;
  if (perms['menu.shift_floor'] === true) return true;

  const roleName = String(currentUser.role_name || currentUser.role?.name || '').toLowerCase();
  if (roleName.includes('адмін') || roleName.includes('admin')) return true;
  if (roleName.includes('начальник')) return true; // начальник зміни / цеху
  if (currentUser.oee_role === 'shift_supervisor') return true;

  return false;
}
